import React from "react";
import { Container, Grid } from "@material-ui/core";
import CardClassrooms from "./CardClassrooms";
import NewClassroom from "./NewClassroom";
import { useRole } from "../../hooks/useRole";

export default function Classrooms() {
  const { isAdmin } = useRole();
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardClassrooms />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewClassroom />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
